import { createRoot, Root } from 'react-dom/client';
import { App } from './App';
import css from './styles.css?inline';
import type { OpenOptions } from './types';

const HOST_ID = 'woman-checkout-embed-host';
const STYLE_ID = 'woman-checkout-embed-styles';

let activeRoot: Root | null = null;
let activeHost: HTMLElement | null = null;

function ensureStyles(): void {
  if (document.getElementById(STYLE_ID)) return;
  const style = document.createElement('style');
  style.id = STYLE_ID;
  style.textContent = css;
  document.head.appendChild(style);
}

function open(options: OpenOptions): void {
  // If already open, close first to avoid stacking modals.
  close();
  ensureStyles();

  const host = document.createElement('div');
  host.id = HOST_ID;
  document.body.appendChild(host);

  const root = createRoot(host);
  activeRoot = root;
  activeHost = host;

  const handleClose = () => {
    options.onClose?.();
    close();
  };

  root.render(<App options={options} onClose={handleClose} />);
}

function close(): void {
  if (activeRoot) {
    activeRoot.unmount();
    activeRoot = null;
  }
  if (activeHost && activeHost.parentNode) {
    activeHost.parentNode.removeChild(activeHost);
    activeHost = null;
  }
}

const api = { open, close };

declare global {
  interface Window {
    WomanCheckout?: typeof api;
  }
}

if (typeof window !== 'undefined') {
  window.WomanCheckout = api;
}

export default api;
